import Modal from "../../Modal"

interface DeleteModalProps {
	onConfirm: () => void,
	onCancel: () => void
}

const DeleteModal = (props: DeleteModalProps) => {
	return (
		<Modal
			title="Are you sure you want to remove the contribution request?"
			onClose={props.onCancel}
		>
			<p>This will hide the contribution from your published site but the shortcode will need to be manually removed from the editor.</p>

			<button className="rgModalButton primary" onClick={props.onConfirm}>Yes, remove Contribution request</button>
			<button className="rgModalButton" onClick={props.onCancel}>No, keep Contribution request</button>
		</Modal>
	)
}

export default DeleteModal;
